// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"6e8519bb","197":"4c462bdc","220":"b7d2f8af","723":"6ff192e4","789":"f8060b36","835":"e6221c38","865":"4d9f1a95"}[chunkId] + ".chunk.js";
};